/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { MCRMLoyaltyDataSchema } from "./MCRMLoyaltyDataSchema.ts";

export const guestResponseSchema = z
	.object({
		id: z.uuid(),
		first_name: z.string().max(63),
		phone: z.string().max(11),
		country_code: z.string(),
		full_phone: z.string(),
		email: z.email().max(254).nullish(),
		balance: z.number().nullable(),
		has_loyalty_profile: z.boolean().optional(),
		adult_consent: z.boolean().optional(),
		loyalty_data: MCRMLoyaltyDataSchema.nullable().describe("Сериализатор данных лояльности."),
	})
	.describe("Сериализатор вывода инфо о текущем пользователе.");
